/**
 * GENERATED by `tools/solve-meeple-anchors.mjs` — do not hand-edit. [P6-meeple-ux] [P6-road-anchors] [D-27]
 *
 * Where a meeple stands on each feature, solved by reading the sprite artwork rather than
 * derived from sub-edge midpoints — the derivation put the starter tile's road meeple on the
 * grass beside its road, which is what made an occupied road look free.
 *
 * Road features use a road-specific objective (be furthest from the road edge in the WORST art
 * variant, and only where the road is still ribbon-wide), because the general "pole of
 * inaccessibility" rule parks a junction meeple in the middle of the village square instead of
 * on the arm it claims. Measured evidence: `tools/road-anchor-report.md`.
 *
 * Coordinates are UNROTATED tile-local units in [-0.5, 0.5]; `x` runs west->east and `z`
 * north->south, matching `geometry.ts`. They survive rotation because the meeple is parented
 * to the tile group, and that group carries the rotation.
 *
 * A `null` entry means the solver could not find a point valid in every art variant of that
 * tile, and the caller should fall back to the geometric derivation.
 */

export interface MeepleAnchor {
  readonly x: number;
  readonly z: number;
}

export const MEEPLE_ANCHORS: Readonly<Record<string, readonly (MeepleAnchor | null)[]>> = {
  A: [{ x: 0, z: 0 }, { x: 0.05, z: 0.3833 }, { x: 0.2722, z: -0.2278 }],
  B: [{ x: 0, z: 0 }, { x: 0.1944, z: 0.2389 }],
  C: [{ x: -0.0056, z: -0.0056 }],
  D: [{ x: -0.0278, z: -0.3833 }, { x: 0.05, z: 0.0167 }, { x: -0.3833, z: -0.3278 }, { x: 0.1833, z: 0.3167 }],
  E: [{ x: -0.0389, z: -0.4056 }, { x: 0.1278, z: 0.1278 }],
  F: [{ x: 0.0167, z: 0.0722 }, { x: 0.4056, z: -0.0944 }, { x: -0.3944, z: 0.0167 }],
  G: [{ x: 0.0389, z: -0.3056 }, { x: 0.4056, z: -0.0944 }, { x: -0.3944, z: 0.0167 }],
  H: [{ x: -0.05, z: -0.4056 }, { x: -0.0278, z: 0.3944 }, { x: 0.2722, z: 0.0056 }],
  I: [{ x: 0.3278, z: -0.05 }, { x: 0.0278, z: 0.3278 }, { x: -0.1056, z: -0.1056 }],
  J: [{ x: -0.0278, z: -0.3833 }, { x: 0.0167, z: -0.0611 }, { x: -0.3389, z: 0.05 }, { x: 0.1167, z: 0.0722 }],
  K: [{ x: -0.0278, z: -0.3944 }, { x: 0.1056, z: -0.0278 }, { x: 0.3389, z: -0.0944 }, { x: -0.0944, z: 0.2389 }],
  L: [{ x: -0.0167, z: -0.4056 }, { x: 0.3389, z: -0.0722 }, { x: -0.1389, z: 0.3722 }, { x: -0.4278, z: 0.0833 }, { x: -0.4056, z: -0.1944 }, { x: 0.3944, z: 0.3611 }, { x: -0.3722, z: 0.4167 }],
  M: [{ x: -0.1389, z: -0.15 }, { x: 0.3167, z: 0.0833 }],
  N: [{ x: -0.1944, z: -0.1611 }, { x: 0.3167, z: 0.0833 }],
  O: [{ x: -0.3056, z: 0.0056 }, { x: 0.3167, z: -0.0389 }, { x: 0.3944, z: -0.2389 }, { x: 0.1389, z: 0.3833 }],
  P: [{ x: -0.3056, z: 0.0056 }, { x: 0.4167, z: -0.0389 }, { x: 0.4056, z: -0.2611 }, { x: 0.3944, z: 0.3833 }],
  Q: [{ x: -0.2056, z: -0.2056 }, { x: 0.0833, z: 0.3833 }],
  R: [{ x: 0.15, z: -0.2167 }, { x: -0.0944, z: 0.4167 }],
  S: [{ x: -0.1167, z: -0.1833 }, { x: -0.0056, z: 0.3944 }, { x: 0.3389, z: 0.4167 }, { x: -0.3944, z: 0.3722 }],
  T: [{ x: 0.1389, z: -0.2611 }, { x: -0.0056, z: 0.4278 }, { x: 0.3389, z: 0.4167 }, { x: -0.3944, z: 0.3722 }],
  U: [{ x: -0.0722, z: -0.0278 }, { x: 0.3833, z: 0.0944 }, { x: -0.3278, z: 0.1611 }],
  V: [{ x: 0.0611, z: 0.0722 }, { x: -0.3056, z: 0.2722 }, { x: 0.3389, z: 0.25 }],
  W: [{ x: 0.3278, z: -0.0722 }, { x: -0.1611, z: 0.3389 }, { x: -0.4278, z: 0.0833 }, { x: -0.3056, z: -0.3056 }, { x: 0.3944, z: 0.3833 }, { x: -0.4056, z: 0.3944 }],
  X: [{ x: 0.0944, z: -0.3944 }, { x: 0.4056, z: -0.0944 }, { x: -0.1278, z: 0.3167 }, { x: -0.3389, z: 0.1389 }, { x: 0.3167, z: -0.3833 }, { x: 0.2722, z: 0.2167 }, { x: -0.4167, z: 0.2833 }, { x: -0.3611, z: -0.4278 }],
};
